<template>
  <div v-if="$companyConfiguration.evaluation.isEnabled()">
    <page-heading
      heading="Категории компетенций"
    >
      <span slot="help"></span>
      <div slot="right">
        <div class="el-row--flex">
          <el-button
            type="primary"
            size="small"
            icon="fas fa-plus"
            @click="openEditDialog"
          >
            Добавить категорию
          </el-button>
        </div>
      </div>
    </page-heading>

    <el-card>
      <categories-component
        ref="categoriesComponent"
        :on-edit-category="openEditDialog"
      ></categories-component>
    </el-card>

    <category-edit-dialog
      ref="editDialog"
      @category-saved="loadCategories"
    >
    </category-edit-dialog>
  </div>
</template>

<script>
import CategoryEditDialog from "@/modules/evaluation/components/category/CategoryEditDialog.vue";
import CategoriesComponent from "@/modules/evaluation/components/category/CategoriesComponent";
import PageHeading from "@/components/PageHeading";

export default {
  name: 'eval-category',
  components: {
    CategoriesComponent,
    CategoryEditDialog,
    PageHeading
  },
  methods: {
    openEditDialog(category = {}) {
      this.$refs.editDialog.open(category);
    },
    loadCategories(){
      if (this.$refs.categoriesComponent) {
        this.$refs.categoriesComponent.loadCategories();
      }
    },
  }
}
</script>

<style scoped lang="scss">
  @import "./src/assets/css/project-variables";
</style>